import React, { Component } from 'react';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Button from 'react-validation/build/button';
import { isEmail } from 'validator';

var error = ''

const required = (value, props) => {
  if (!value || (props.isCheckable && !props.checked)) {
    error = error + 'error';
    return <span class='form-error active'><strong>فیلد نام الزامی است</strong></span>;
  }
};

const email = (value) => {
  if (!isEmail(value)) {
    error = error + 'error';
    return <span className="form-error is-visible">${value} is not a valid email.</span>;
  }
};

const isEqual = (value, props, components) => {
  const bothUsed = components.password[0].isUsed && components.confirm[0].isUsed;
  const bothChanged = components.password[0].isChanged && components.confirm[0].isChanged;

  if (bothChanged && bothUsed && components.password[0].value !== components.confirm[0].value) {
    return <span className="form-error is-visible">Passwords are not equal.</span>;
  }
};



export default class Login extends Component {
  

  handleClick = () => {
    //error = '';
     this.form.validateAll();

     console.log(error,'hoy');


  };

  handleSubmit = (event) => {
    event.preventDefault();
    
    console.log('hi baby')
    console.log(event);
  };


  render() {

      return(
        <>
      <div class="register_panel">
          <div class="container">
              <div class="register-myself" >
                    <Form class="form form-myself" ref={c => { this.form = c }} onSubmit={this.handleSubmit}>
                                <div class="form-body">
                                    <div class="form-group">
                                        <label class="label-control">اطلاعات کاربری</label>
                                        {/* <div style={{color:'red', marginBottom:10}}>{this.state.error}</div>    */}
                                            <Input
                                                id= "Name"
                                                name= "Name"
                                                type="text"
                                                placeholder = "نام کامل خود را وارد کنید."
                                                validations={[required]}
                                                className="form-control" 
                                               // msgOnError: <span class='form-error active'><strong>فیلد نام الزامی است</strong></span>, // Optional.[String].Default: "" Show your custom error message no matter what when it has error if it is provied.

                                              
                                        />
                                    </div>
                                    <div class="form-group">       
                                            <Input
                                                id= "email"
                                                name= "email"
                                                type= "text"
                                                placeholder= "ایمیل خود را وارد کنید."
                                                validations={[required, email]}
                                                className="form-control" 

                                               // msgOnError: <span class='form-error active'><strong>فیلد ایمیل الزامی است</strong></span>, 
       
                                            />
                                        </div>
                                        <div class="form-group">       
                                            <Input
                                                id="mobile"
                                                name= "mobile"
                                                type= "text"
                                                placeholder="شماره موبایل خود را وارد کنید."
                                                validations={[required]}
                                                className="form-control" 
                                               // msgOnError: <span class='form-error active'><strong>فیلد الزامی است</strong></span>, 
       
                                            
                                            />
                                        </div>
                                        <div class="form-group">       
                                            <Input
                                                id="password"
                                                name= "password"
                                                type= "password"
                                                placeholder= "پسورد خود را وارد کنید."
                                                validations={[required]}
                                                className="form-control" 
                                        //        msgOnError: <span class='form-error active'><strong>فیلد الزامی است</strong></span>, 
       
                                            />
                                        </div>
                                        <div class="form-group">       
                                            <Input
                                                id="password_confirmation"
                                                name= "password_confirmation"
                                                type= "password"
                                                placeholder= "تکرارپسورد خود را وارد کنید."
                                                validations={[required]}
                                                className="form-control" 
                                              //  msgOnError: <span class='form-error active'><strong>فیلد الزامی است</strong></span>, 
       

                                            />
                                        </div>
                                    <div class="form-group">
                                       <button className="button" type="button" onClick={this.handleClick} class="btn btn-info">عضویت</button>
                                    </div>
                                </div>
                    </Form>
              </div>
          </div>
    
      {/* </div> */}
      </div>
      </>
      )
  }
}
